export enum CrossProductScope {
	RECENTS = 'rovo-cross-product.recents',
	RESULTS = 'rovo-cross-product.results',
}
